module.exports = __webpack_public_path__ + "static/img/编组 37@2x(1).fadb625b.png";